import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import TSButton from 'components/common/Button/Button';
import {
  useAddEmergencyContactMutation,
  useUpdateEmergencyContactMutation,
} from 'app/api/usersApiSlice';

const EmergencyContact = ({
  contact,
  userId,
  index,
  isModal = false,
  toggleModal,
}) => {
  const [contactPhone, setContactPhone] = useState(contact?.ContactPhone || '');
  const [contactName, setContactName] = useState(contact?.ContactName || '');
  const [contactEmail, setContactEmail] = useState(contact?.ContactEmail || '');
  const [relationship, setRelationship] = useState(contact?.Relationship || '');
  const [isPrimary, setIsPrimary] = useState(contact?.IsPrimary || false);
  const [editMode, setEditMode] = useState(!contact ? true : false);
  const [phoneError, setPhoneError] = useState(false);

  const [
    addEmergencyContact,
    {
      data: addEmergencyContactData,
      isLoading: isAddEmergencyContactLoading,
      isError: isAddEmergencyContactError,
      isSuccess: isAddEmergencyContactSuccess,
    },
  ] = useAddEmergencyContactMutation();

  const [
    updateEmergencyContact,
    {
      data: updateEmergencyContactData,
      isLoading: isUpdateEmergencyContactLoading,
      isError: isUpdateEmergencyContactError,
      isSuccess: isUpdateEmergencyContactSuccess,
    },
  ] = useUpdateEmergencyContactMutation();

  const handleCancel = () => {
    setContactPhone(contact?.ContactPhone || '');
    setContactName(contact?.ContactName || '');
    setContactEmail(contact?.ContactEmail || '');
    setRelationship(contact?.Relationship || '');
    setIsPrimary(contact?.IsPrimary || false);
    setPhoneError(false);
    setEditMode(false);
    if (isModal) toggleModal(false);
  };

  const handleSave = () => {
    // Call API to save contact details
    // On success, update local state and exit edit mode

    if (!matchIsValidTel(contactPhone)) {
      setPhoneError(true);
      return;
    }
    setPhoneError(false);

    if (contact?.EmergencyContactID) {
      updateEmergencyContact({
        contact_id: contact.EmergencyContactID,
        full_name: contactName,
        email_address: contactEmail,
        phone_number: contactPhone,
        relationship,
        is_primary: isPrimary,
      });
    } else {
      addEmergencyContact({
        user_id: userId,
        full_name: contactName,
        email_address: contactEmail,
        phone_number: contactPhone,
        relationship,
        is_primary: isPrimary,
      });
    }
    setEditMode(false);
    if (isModal) toggleModal(false);
  };

  return (
    <div className="flex flex-col gap-4">
      {(editMode || !contact) && (
        <TextField
          disabled={!editMode}
          id={`contact-name-${index}`}
          label="Contact Name"
          defaultValue={contactName}
          onChange={(e) => setContactName(e.target.value)}
        />
      )}
      <MuiTelInput
        disabled={!editMode}
        id={`contact-phone-${index}`}
        label="Contact Phone"
        defaultCountry="AU"
        value={contactPhone}
        onChange={(value) => {
          setContactPhone(value);
          setPhoneError(false);
        }}
        error={phoneError}
        helperText={
          phoneError
            ? 'Enter a valid phone number, including country code'
            : ''
        }
      />
      <TextField
        disabled={!editMode}
        id={`contact-email-${index}`}
        label="Contact Email"
        defaultValue={contactEmail}
        onChange={(e) => setContactEmail(e.target.value)}
      />
      <TextField
        disabled={!editMode}
        id={`relationship-${index}`}
        label="Relationship"
        defaultValue={relationship}
        onChange={(e) => setRelationship(e.target.value)}
      />
      <FormControlLabel
        disabled={!editMode}
        control={<Checkbox defaultChecked={isPrimary} />}
        label="Default Contact"
        onChange={(e) => setIsPrimary(e.target.checked)}
      />
      <div className="flex gap-2">
        {(editMode || !contact) && (
          <TSButton
            btnText={contact ? 'Update' : 'Save'}
            onClickFunc={() => handleSave()}
          />
        )}
        {!editMode && contact && (
          <TSButton btnText="Edit" onClickFunc={() => setEditMode(true)} />
        )}
        {(editMode || !contact) && (
          <TSButton
            btnText="Cancel"
            btnVariant="outlined"
            onClickFunc={() => handleCancel()}
          />
        )}
      </div>
    </div>
  );
};

export default EmergencyContact;
